export default {
  data() {
    return {
      arrSigns: [
        "w_gate",
        "w_9.2",
        "w_8.5",
        "w_7.5",
        "w_6.4",
        "w_5.7",
        "w_5.0",
        "w_4.6",
        "w_4.0",
        "w_3.6",
        "w_3.5",
        "w_3.0",
        "w_2.7",
        "w_2.5",
        "w_2.3",
        "w_1.4",
        "w_1.1",
        "w_0.7",
        "w_0.5",
        "b_mstart",
        "b_1.5",
        "b_2.8",
        "b_3.5",
        "b_4.2",
        "b_4.9",
        "b_5.9",
        "b_6.6",
        "b_7.3",
        "b_7.7",
        "b_8.5",
        "b_9.6",
        "b_10.0",
        "b_10.6"
      ]
    };
  },
  methods: {
    mapLayerSummeropsCalloutsAdd() {
      this.initPollSummeropsCallouts();
      this.map.addSource("summerops-callouts-source", {
        type: "geojson",
        data: this.computedSummeropsCalloutsGeoJson
      });

      // loop through arrSigns array and add a layer for each sign
      for (let i = 0; i < this.arrSigns.length; i++) {
        let url =
          "https://d1upyp0je0gcjj.cloudfront.net/wintertrails/callouts/" +
          this.arrSigns[i] +
          ".png";
        let addImage = "icon-callouts-" + this.arrSigns[i];
        let id = "summerops-callouts-" + this.arrSigns[i];
        let iconImage = "icon-callouts-" + this.arrSigns[i];
        this.map.loadImage(url, (error, image) => {
          this.map.addImage(addImage, image);
          this.map.addLayer({
            filter: ["==", "icon", this.arrSigns[i]],
            id: id,
            type: "symbol",
            source: "summerops-callouts-source",
            layout: {
              "icon-image": iconImage,
              "icon-size": 0.125,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(id, "marker-layer-points");
        });
      }
    },
    mapLayerSummeropsCalloutsRemove() {
      this.cancelPollLiftmaintenanceLifttowers();
      // remove icons loop
      // remove layers loop
      for (let i = 0; i < this.arrSigns.length; i++) {
        let r = "icon-callouts-" + this.arrSigns[i];
        this.map.removeImage(r);
      }
      // remove layers loop
      for (let i = 0; i < this.arrSigns.length; i++) {
        let r = "summerops-callouts-" + this.arrSigns[i];
        this.map.removeLayer(r);
      }
      this.map.removeSource("summerops-callouts-source");
    },
    initPollSummeropsCallouts() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/wintertrails/callouts",
        dept: "summerops",
        layer: "callouts",
        token: this.computedAuthToken
      });
      this.pollSummeropsCalloutsInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/wintertrails/callouts",
          dept: "summerops",
          layer: "callouts",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollSummeropsCallouts() {
      this.pollSummeropsCalloutsInterval = clearInterval(
        this.pollSummeropsCalloutsInterval
      );
    }
  },
  computed: {
    computedSummeropsCalloutsGeoJson() {
      return this.$store.state.mapLayers.summerops.layers.callouts.geojson;
    },
    computedSummeropsCalloutsMapVisibility() {
      return this.$store.state.mapLayers.summerops.layers.callouts.visibility
        .mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.summerops.layers.callouts.geojson": {
      handler() {
        if (this.computedSummeropsCalloutsGeoJson) {
          this.mapLayerSummeropsCalloutsRemove();
          this.mapLayerSummeropsCalloutsAdd();
        }
      }
    },
    "$store.state.mapLayers.summerops.layers.callouts.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerSummeropsCalloutsAdd();
      } else {
        this.mapLayerSummeropsCalloutsRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollSummeropsCallouts();
  }
};
